export const groupOrdersByMarket = (data) =>
	data.reduce((acc, item) => {
		const { name } = item.market;

		acc[name] = acc[name] || [];

		acc[name].push(item);

		return acc;
	}, {});
